<template>
    <section class="container-fluid header-list-type-2">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="wrp">
                        <div class="content">
                            <h1 class="name">{{ $t('views.audiences.title') }}</h1>
                            <p>{{ $t('views.audiences.description') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "AudiencesHeader",
    }
</script>